/* ===== Estilo Alegria =====
   Textos, logotipo, enlace de Google y prefijo de ilustraciones: en el snippet
   snippets/hr-datalayer-head.liquid (AG_BENEF, AG_EDITORIAL, AG_LOGO,
   AG_RESENAS, AG_ILUS). Aqui solo el comportamiento. */
(function () {
  var BASE = window.AG_ILUS || 'https://cdn.shopify.com/s/files/1/0968/5785/0188/files/alegria-trazo-';
  var LOGO = window.AG_LOGO || '';
  var BENEF = window.AG_BENEF || [
    ['Envío gratis en tu primer pedido', 'En península.'],
    ['Devoluciones gratis en 30 días', 'Sin preguntas.'],
    ['Cuidado al cliente', '100% garantizado']
  ];
  var ED = window.AG_EDITORIAL || {
    titular: 'Regalos que se quedan en casa, no en el cajón.',
    sub: 'Cosas que Léa regalaría (y se quedaría para ella)'
  };
  var RESENAS = window.AG_RESENAS || '';
  var N1 = {
    'decoracion': 'decoracion',
    'mesa y cocina': 'mesa-y-cocina',
    'accesorios y papeleria': 'accesorios-y-papeleria',
    'regalos': 'regalos'
  };
  var N2 = {
    'ver todos los regalos': 'regalos',
    'para ella': 'regalo', 'para el': 'regalo', 'para tu amiga': 'regalo',
    'para mama': 'regalo', 'para papa': 'regalo', 'para tu pareja': 'regalo',
    'menos de 20': 'regalo', 'menos de 30': 'regalo', 'menos de 50': 'regalo'
  };
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<circle cx="12" cy="12" r="12" fill="#fb6738"></circle>'
    + '<path d="M7 12.3l3.3 3.3L17.2 8.7" fill="none" stroke="#ffffff" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"></path>'
    + '</svg>';

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[←→]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function url(k, w) { return BASE + k + '.png?width=' + (w || 440); }
  function busca(t, tabla) {
    var n = norm(t);
    if (tabla[n]) return tabla[n];
    for (var k in tabla) { if (n.indexOf(k) === 0) return tabla[k]; }
    return null;
  }

  /* El logotipo original es de 1536x1024 pero la marca solo ocupa 1375x359:
     el 65% del fichero es espacio vacio, y eso es lo que engordaba la cabecera.
     Aqui se cambia por la version recortada; el alto lo pone el CSS. */
  function logoCompacto() {
    if (!LOGO) return;
    var l = document.querySelectorAll('.header__heading-link img, .header__heading img');
    for (var i = 0; i < l.length; i++) {
      if (l[i].dataset.agLogo) continue;
      l[i].dataset.agLogo = '1';
      l[i].removeAttribute('srcset');
      l[i].removeAttribute('sizes');
      l[i].removeAttribute('width');
      l[i].removeAttribute('height');
      l[i].setAttribute('src', LOGO + '?width=600');
    }
  }

  function limpiarBadges() {
    var l = document.querySelectorAll('.badge-stock, .badge-ultima');
    for (var i = 0; i < l.length; i++) {
      var t = l[i].textContent.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}️]/gu, '').trim();
      if (t && t !== l[i].textContent) { l[i].textContent = t; }
    }
  }

  function menuEscritorio() {
    var ds = document.querySelectorAll('.header__inline-menu details');
    for (var i = 0; i < ds.length; i++) {
      var sum = ds[i].querySelector('summary span');
      var ul = ds[i].querySelector('ul.header__submenu');
      if (!sum || !ul || ul.querySelector('.ag-sub-ilus')) continue;
      var base = busca(sum.textContent, N1);
      if (!base) continue;
      var col = document.createElement('div');
      col.className = 'ag-cols';
      while (ul.firstElementChild) { col.appendChild(ul.firstElementChild); }
      ul.appendChild(col);
      var box = document.createElement('div');
      box.className = 'ag-sub-ilus';
      box.innerHTML = '<img src="' + url(base, 360) + '" alt="">';
      ul.appendChild(box);
      (function (box, base, col) {
        var img = box.querySelector('img');
        var actual = base;
        function cambia(k) {
          if (!k || k === actual) return;
          actual = k;
          box.classList.add('ag-cambia');
          var nueva = new Image();
          nueva.onload = function () { img.src = nueva.src; box.classList.remove('ag-cambia'); };
          nueva.src = url(k, 360);
        }
        var links = col.querySelectorAll('a');
        for (var j = 0; j < links.length; j++) {
          (function (a) {
            var k = busca(a.textContent, N2) || base;
            a.addEventListener('mouseenter', function () { cambia(k); });
            a.addEventListener('focus', function () { cambia(k); });
          })(links[j]);
        }
        col.addEventListener('mouseleave', function () { cambia(base); });
      })(box, base, col);
    }
  }

  function menuMovil() {
    var hd = document.querySelector('header-drawer');
    if (!hd) return;
    var dets = hd.querySelectorAll('.menu-drawer__menu > li > details');
    for (var i = 0; i < dets.length; i++) {
      var sum = dets[i].querySelector('summary');
      var inner = dets[i].querySelector('.menu-drawer__inner-submenu');
      if (!sum || !inner || inner.querySelector('.ag-cajon-ilus')) continue;
      var base = busca(sum.textContent, N1);
      if (!base) continue;
      var lista = inner.querySelector('ul');
      var ilus = document.createElement('span');
      ilus.className = 'ag-cajon-ilus';
      ilus.innerHTML = '<img src="' + url(base, 480) + '" alt="" loading="lazy">';
      if (lista && lista.nextSibling) { inner.insertBefore(ilus, lista.nextSibling); } else { inner.appendChild(ilus); }
    }
  }

  function cabeceraMovil() {
    var sec = document.querySelector('.section-header');
    var anun = document.querySelector('.announcement-bar-section');
    if (!sec) return;
    function alto() {
      var h = anun ? Math.round(anun.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--ag-anun', h + 'px');
    }
    alto();
    window.addEventListener('resize', alto);
    var ultimo = window.pageYOffset, bloqueo = false;
    window.addEventListener('scroll', function () {
      if (bloqueo) return;
      bloqueo = true;
      window.requestAnimationFrame(function () {
        bloqueo = false;
        if (!window.matchMedia('(max-width: 749px)').matches) { sec.classList.remove('ag-oculta'); ultimo = window.pageYOffset; return; }
        var y = window.pageYOffset;
        if (y < 160) { sec.classList.remove('ag-oculta'); ultimo = y; return; }
        if (y > ultimo + 8) { sec.classList.add('ag-oculta'); }
        else if (y < ultimo - 8) { sec.classList.remove('ag-oculta'); }
        ultimo = y;
      });
    }, { passive: true });
  }

  function verTodo() {
    var cols = document.querySelectorAll('.collection');
    for (var i = 0; i < cols.length; i++) {
      var t = cols[i].querySelector('.collection__title');
      var v2 = cols[i].querySelector('.collection__view-all');
      if (t && v2 && !t.contains(v2)) { t.classList.add('ag-fila'); t.appendChild(v2); }
    }
  }

  function aperturaRegalos() {
    var b = document.querySelector('.alegria-band');
    if (!b || b.dataset.agEd) return;
    b.dataset.agEd = '1';
    var big = b.querySelector('.alegria-band__big');
    if (big) { big.textContent = ED.titular; }
    var cej = document.createElement('span');
    cej.className = 'ag-cejilla';
    cej.textContent = 'Regalos';
    if (big) { b.insertBefore(cej, big); } else { b.appendChild(cej); }
    var sub = document.createElement('p');
    sub.className = 'ag-band-sub';
    sub.textContent = ED.sub;
    b.appendChild(sub);
    var a = document.createElement('a');
    a.className = 'ag-band-cta';
    a.href = '/collections/regalos-originales';
    a.textContent = 'Ver regalos →';
    b.appendChild(a);
  }

  function beneficios() {
    if (document.getElementById('ag-gar')) return;
    var band = document.querySelector('.alegria-band');
    if (!band) return;
    var d = document.createElement('div');
    d.id = 'ag-gar';
    var h = '<div class="in">';
    for (var i = 0; i < BENEF.length; i++) {
      h += '<article><span class="ic">' + CHECK + '</span><span><h3>' + BENEF[i][0] + '</h3><p>' + BENEF[i][1] + '</p></span></article>';
    }
    d.innerHTML = h + '</div>';
    band.parentNode.insertBefore(d, band);
  }

  function resenaLinea() {
    var rev = document.querySelector('.alegria-reviews');
    if (!rev || rev.dataset.agLinea) return;
    var num = rev.querySelector('.alegria-reviews__num');
    var estrellas = rev.querySelector('.alegria-stars');
    var texto = rev.querySelector('.alegria-reviews__text');
    if (!num || !estrellas) return;
    var nota = num.textContent.replace(/\s+/g, ' ').trim();
    var m = (texto ? texto.textContent : '').match(/(\d+)\s*rese/i);
    var linea = document.createElement('p');
    linea.className = 'ag-rating';
    linea.appendChild(estrellas);
    var t = document.createElement('span');
    t.textContent = nota + ' en Google' + (m ? ' · ' + m[1] + ' reseñas' : '');
    linea.appendChild(t);
    rev.innerHTML = '';
    rev.appendChild(linea);
    rev.dataset.agLinea = '1';
    var gar = document.getElementById('ag-gar');
    if (gar) { gar.appendChild(rev); }
  }

  function opiniones() {
    var op = document.querySelector('.alegria-op');
    if (!op || op.dataset.agOp) return;
    op.dataset.agOp = '1';
    var lista = op.querySelector('.alegria-op__list');
    if (!lista) return;
    var cards = lista.querySelectorAll('.alegria-op__card');
    for (var i = 0; i < cards.length; i++) {
      if (/es todo ideal/i.test(cards[i].textContent)) { lista.insertBefore(cards[i], lista.firstChild); break; }
    }
    if (!RESENAS || op.querySelector('.ag-vermas')) return;
    var cuenta = op.querySelector('.alegria-op__count');
    var m = cuenta ? (cuenta.textContent || '').match(/(\d+)/) : null;
    var a = document.createElement('a');
    a.className = 'ag-vermas';
    a.href = RESENAS;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = m ? ('Ver las ' + m[1] + ' reseñas en Google →') : 'Ver más reseñas en Google →';
    if (lista.parentNode) { lista.parentNode.insertBefore(a, lista.nextSibling); }
  }

  function montar() {
    logoCompacto(); limpiarBadges(); menuEscritorio(); menuMovil(); cabeceraMovil(); verTodo();
    aperturaRegalos(); beneficios(); resenaLinea(); opiniones();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', montar); } else { montar(); }
})();

/* ===== Desplegables propios del buscador. El select nativo sigue ahi y manda. =====
   Ojo con el marcado del tema: cada campo va envuelto en
   <label class="alegria-finder__field">, y el control de esa etiqueta es el
   select. Cualquier clic que llegue hasta la etiqueta la activa y abre el
   desplegable del sistema encima del nuestro. Por eso tanto el boton como
   cada opcion cortan el evento. */
(function () {
  function monta(sel) {
    if (sel.dataset.agListo) return;
    sel.dataset.agListo = '1';
    var caja = document.createElement('div');
    caja.className = 'ag-sel';
    sel.parentNode.insertBefore(caja, sel);
    caja.appendChild(sel);

    var bot = document.createElement('button');
    bot.type = 'button';
    bot.className = 'ag-sel__bot';
    bot.setAttribute('aria-haspopup', 'listbox');
    bot.setAttribute('aria-expanded', 'false');

    var lista = document.createElement('div');
    lista.className = 'ag-sel__lista';
    lista.setAttribute('role', 'listbox');

    caja.appendChild(bot);
    caja.appendChild(lista);

    function cierra() {
      caja.removeAttribute('data-abierto');
      bot.setAttribute('aria-expanded', 'false');
    }
    function abre() {
      caja.setAttribute('data-abierto', '1');
      bot.setAttribute('aria-expanded', 'true');
      var s = lista.querySelector('[aria-selected="true"]');
      if (s) s.focus();
    }
    function pinta() {
      var o = sel.options[sel.selectedIndex];
      bot.textContent = o ? o.text : '';
      lista.innerHTML = '';
      for (var i = 0; i < sel.options.length; i++) {
        (function (op, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ag-sel__op';
          b.setAttribute('role', 'option');
          b.setAttribute('aria-selected', idx === sel.selectedIndex ? 'true' : 'false');
          b.appendChild(document.createTextNode(op.text));
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            sel.selectedIndex = idx;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            cierra();
            pinta();
            bot.focus();
          });
          lista.appendChild(b);
        })(sel.options[i], i);
      }
    }

    bot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (caja.getAttribute('data-abierto')) { cierra(); } else { abre(); }
    });
    caja.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cierra(); bot.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      if (!caja.getAttribute('data-abierto')) { abre(); return; }
      var ops = [].slice.call(lista.querySelectorAll('.ag-sel__op'));
      var i = ops.indexOf(document.activeElement);
      var j = Math.max(0, Math.min(ops.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)));
      ops[j].focus();
    });
    document.addEventListener('click', function (e) { if (!caja.contains(e.target)) cierra(); });
    sel.addEventListener('change', pinta);
    pinta();
  }

  function todos() {
    var l = document.querySelectorAll('.alegria-finder__select');
    for (var i = 0; i < l.length; i++) { monta(l[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todos); } else { todos(); }
})();

/* ===== Muestras de color en las fichas de la rejilla =====
   Lee /products/<handle>.js, que es publico, solo cuando la ficha esta cerca de
   pantalla, y guarda el resultado en sessionStorage (tambien cuando el producto
   no tiene color, para no volver a pedirlo).
   Se mide con getBoundingClientRect y no con IntersectionObserver porque este
   ultimo no dispara mientras la pestana esta en segundo plano.
   Ojo: Dawn deja dos bloques de informacion por ficha, uno oculto (el de texto
   sobre la foto) y otro visible; hay que escribir en el que esta visible.
   Lo suyo seria que esto saliera de Liquid, sin ninguna peticion. */
(function () {
  var MAPA = {
    'naranja': '#FF8A00', 'naranja neon': '#FF7A00',
    'rosa': '#FFC0CB', 'rosa fuerte': '#F5568E', 'rosa cereza azul electrico': '#EB4776',
    'rojo': '#F61F1F', 'frambuesa': '#EF1574', 'magenta': '#D6219B',
    'amarillo': '#FFE500', 'amarilla': '#FFE500', 'amarillo profundo': '#E8B400',
    'azul': '#005BD3', 'azul claro': '#7FB6E8', 'azul claro lavanda': '#B8D9EF',
    'verde': '#05AA3D', 'verde menta': '#8FD9B6', 'verde neon': '#5BE800',
    'blanco': '#FFFFFF', 'blanco lavanda': '#C7A6ED',
    'purpura': '#A54DCF', 'lila': '#C39BE8', 'violeta': '#7B3FE4',
    'arena': '#D9C3A0', 'terracotta': '#C1643C', 'marron': '#7A4A2B',
    'beige': '#E4D5BE', 'ocre': '#C98A1E', 'turquesa': '#2FC6C0',
    'melocoton': '#F7B187', 'moonlight': '#C9D3E0', 'jade': '#7FBFA8', 'zafiro': '#2E5FA3'
  };
  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/&/g, ' ').replace(/\by\b/g, ' ')
      .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function hex(v) { return MAPA[norm(v)] || null; }

  /* Es un producto de color cuando tiene una sola opcion, dos valores o mas, y
     todos los valores son colores conocidos. Asi las tallas y los importes de
     la tarjeta regalo se quedan fuera solos. */
  function opcionColor(p) {
    if (!p || !p.options || p.options.length !== 1) return false;
    var vals = p.options[0].values || [];
    if (vals.length < 2) return false;
    for (var i = 0; i < vals.length; i++) { if (!hex(vals[i])) return false; }
    return true;
  }

  function seVe(el) { return !!(el && el.getClientRects().length); }

  function destino(card) {
    var cands = card.querySelectorAll('.card-information, .card__information');
    for (var i = 0; i < cands.length; i++) { if (seVe(cands[i])) return cands[i]; }
    return null;
  }

  function anchoImagen(u, w) {
    if (!u) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function monta(card, p) {
    if (card.querySelector('.ag-colores')) return;
    var info = destino(card);
    var img = card.querySelector('.card__media img');
    var enlace = card.querySelector('a.full-unstyled-link');
    if (!info || !img) return;
    var origen = {
      src: img.getAttribute('src'),
      srcset: img.getAttribute('srcset'),
      sizes: img.getAttribute('sizes'),
      href: enlace ? enlace.getAttribute('href') : null
    };
    var fila = document.createElement('div');
    fila.className = 'ag-colores';
    var elegido = null;

    function pon(v) {
      var f = v && v.featured_image && v.featured_image.src;
      if (!f) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', anchoImagen(f, 700));
    }
    function vuelve() {
      if (elegido) { pon(elegido); return; }
      if (origen.srcset) img.setAttribute('srcset', origen.srcset);
      if (origen.sizes) img.setAttribute('sizes', origen.sizes);
      if (origen.src) img.setAttribute('src', origen.src);
    }

    var puestos = 0;
    for (var i = 0; i < p.variants.length && puestos < 6; i++) {
      (function (v) {
        var c = hex(v.title);
        if (!c) return;
        puestos++;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ag-color';
        b.style.setProperty('--c', c);
        b.title = v.title;
        b.setAttribute('aria-label', v.title);
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('mouseenter', function () { pon(v); });
        b.addEventListener('focus', function () { pon(v); });
        b.addEventListener('mouseleave', vuelve);
        b.addEventListener('blur', vuelve);
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          elegido = v;
          var todos = fila.querySelectorAll('.ag-color');
          for (var j = 0; j < todos.length; j++) { todos[j].setAttribute('aria-pressed', 'false'); }
          b.setAttribute('aria-pressed', 'true');
          pon(v);
          if (enlace && origen.href) {
            enlace.setAttribute('href', origen.href.split('?')[0] + '?variant=' + v.id);
          }
        });
        fila.appendChild(b);
      })(p.variants[i]);
    }
    if (!puestos) return;
    if (p.variants.length > puestos) {
      var mas = document.createElement('span');
      mas.className = 'ag-colores__mas';
      mas.textContent = '+' + (p.variants.length - puestos);
      fila.appendChild(mas);
    }
    info.appendChild(fila);
  }

  function carga(card) {
    var a = card.querySelector('a.full-unstyled-link');
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    if (!m) return;
    var handle = m[1];
    var clave = 'agcol:' + handle;
    var guardado = null;
    try { guardado = window.sessionStorage.getItem(clave); } catch (e) {}
    if (guardado === 'no') return;
    if (guardado) {
      try { monta(card, JSON.parse(guardado)); return; } catch (e) {}
    }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        if (!opcionColor(p)) {
          try { window.sessionStorage.setItem(clave, 'no'); } catch (e) {}
          return;
        }
        var corto = {
          options: p.options,
          variants: p.variants.map(function (v) {
            return { id: v.id, title: v.title, featured_image: v.featured_image ? { src: v.featured_image.src } : null };
          })
        };
        try { window.sessionStorage.setItem(clave, JSON.stringify(corto)); } catch (e) {}
        monta(card, corto);
      })
      .catch(function () {});
  }

  function cerca(el) {
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    var alto = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.top < alto + 500 && r.bottom > -500;
  }

  function revisa() {
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.agCol) continue;
      if (!cerca(cards[i])) continue;
      cards[i].dataset.agCol = '1';
      carga(cards[i]);
    }
  }

  var pendiente = null;
  function pide() {
    if (pendiente) return;
    pendiente = window.setTimeout(function () { pendiente = null; revisa(); }, 120);
  }

  function arranca() {
    revisa();
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide);
    document.addEventListener('shopify:section:load', pide);
    document.addEventListener('visibilitychange', pide);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', arranca); } else { arranca(); }
})();


/* PRUEBA INSTAGRAM V13: enfasis del beneficio, sin sustituir el boton ni sus eventos. */
(function () {
  function startAnnouncementStyle() {
    var section = document.querySelector('.announcement-bar-section');
    if (!section) return;
    function formatAnnouncement() {
      section.querySelectorAll('.announcement-bar__message').forEach(function (message) {
        var cta = message.querySelector('.ag-cap-cta');
        if (!cta) return;
        if (!cta.querySelector('.ag-cap-cta-label')) {
          var ctaLabel = document.createElement('span');
          ctaLabel.className = 'ag-cap-cta-label';
          ctaLabel.textContent = cta.textContent;
          cta.textContent = '';
          cta.appendChild(ctaLabel);
        }
        if (message.querySelector('.ag-announcement-copy')) return;
        var nodes = Array.from(message.childNodes).filter(function (node) { return node.nodeType === 3; });
        var text = nodes.map(function (node) { return node.textContent; }).join('');
        var match = text.match(/^(\s*Envío\s+GRATIS)([\s\S]*)$/);
        if (!match || !nodes.length) return;
        var copy = document.createElement('span');
        copy.className = 'ag-announcement-copy';
        var strong = document.createElement('strong');
        strong.textContent = match[1];
        copy.appendChild(strong);
        copy.appendChild(document.createTextNode(match[2]));
        message.insertBefore(copy, nodes[0]);
        nodes.forEach(function (node) { node.remove(); });
      });
    }
    formatAnnouncement();
    new MutationObserver(formatAnnouncement).observe(section, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAnnouncementStyle, { once: true });
  else startAnnouncementStyle();
})();

/* PRUEBA INSTAGRAM V25 · mensaje hasta los bordes · 19 sep 2026 */
(function () {
  var current = null;
  var serial = 0;
  var phrase = 'Concept Store · Objetos con personalidad · Para regalar y regalarte';
  function installWaveMessage() {
    var host = document.querySelector('html[data-p="1"]:has(.alegria-home-section) .section-header .header-wrapper');
    if (current && current.host === host && host.isConnected) return;
    if (current) { current.destroy(); current = null; }
    if (!host || !window.ResizeObserver) return;
    var section = host.closest('.section-header');
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.classList.add('ag-wave-message');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var label = document.createElement('span');
    label.className = 'visually-hidden ag-wave-message-label';
    label.textContent = phrase + '.';
    host.appendChild(svg);
    host.appendChild(label);
    var id = 'ag-wave-message-path-' + (++serial);
    var clipId = id + '-clip';
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hovered = false;
    var headerVisible = true;
    var alive = true;
    var renderFrame = 0;
    function element(name, attrs) {
      var el = document.createElementNS(ns, name);
      Object.keys(attrs || {}).forEach(function (key) { el.setAttribute(key, attrs[key]); });
      return el;
    }
    function syncMotion() {
      var hidden = document.hidden || !headerVisible || section.classList.contains('ag-oculta');
      var menuOpen = section.querySelector('details[open]');
      var paused = motion.matches || hovered || hidden || !!menuOpen;
      if (paused) svg.pauseAnimations(); else svg.unpauseAnimations();
    }
    function render() {
      renderFrame = 0;
      if (!alive || !host.isConnected) return;
      var bounds = host.getBoundingClientRect();
      var width = bounds.width;
      var height = bounds.height;
      var lower = getComputedStyle(host, '::before');
      var upper = getComputedStyle(host, '::after');
      var outerWave = -parseFloat(lower.bottom);
      var creamExtension = -parseFloat(upper.bottom);
      var maskParts = upper.maskSize.split(',');
      var creamWave = parseFloat(maskParts[maskParts.length - 1].trim().split(/\s+/).pop());
      if (!width || !height || !(outerWave > 0) || !Number.isFinite(creamWave)) {
        svg.style.display = 'none'; return;
      }
      svg.style.display = '';
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + (height + outerWave));
      svg.style.height = (height + outerWave) + 'px';
      var fontSize = parseFloat(getComputedStyle(svg).fontSize);
      var baseline = height + (creamExtension - creamWave) / 2 + fontSize * .33;
      var amplitude = (outerWave + creamWave) / 2;
      function x(value) { return value * width / 1440; }
      function y(value) { return baseline + amplitude * value / 100; }
      var d = 'M-32 ' + y(26) + ' L0 ' + y(26) + ' C' + x(68) + ' ' + y(26) + ' ' + x(136) + ' ' + y(79) + ' ' + x(204) + ' ' + y(79) +
        ' C' + x(377) + ' ' + y(79) + ' ' + x(551) + ' ' + y(17) + ' ' + x(724) + ' ' + y(17) +
        ' C' + x(963) + ' ' + y(17) + ' ' + x(1201) + ' ' + y(35) + ' ' + width + ' ' + y(35) + ' L' + (width + 32) + ' ' + y(35);
      svg.replaceChildren();
      var defs = element('defs');
      var path = element('path', { id: id, d: d });
      var clip = element('clipPath', { id: clipId });
      var left = 0;
      clip.appendChild(element('rect', { x: left, y: 0, width: Math.max(0, width - left * 2), height: height + outerWave }));
      defs.appendChild(path); defs.appendChild(clip); svg.appendChild(defs);
      var unit = phrase + '  ·  ';
      var measure = element('text', { visibility: 'hidden', 'xml:space': 'preserve' });
      measure.textContent = unit;
      svg.appendChild(measure);
      var period = measure.getComputedTextLength();
      measure.remove();
      if (!(period > 0)) return;
      var text = element('text', { 'clip-path': 'url(#' + clipId + ')', 'xml:space': 'preserve' });
      var textPath = element('textPath', { href: '#' + id, 'text-anchor': 'start', spacing: 'exact', startOffset: 0 });
      textPath.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + id);
      if (motion.matches) {
        textPath.textContent = width < 600 ? 'Concept Store · Objetos con personalidad' : phrase;
        textPath.setAttribute('text-anchor', 'middle');
        textPath.setAttribute('startOffset', '50%');
      } else {
        textPath.textContent = unit.repeat(Math.ceil(path.getTotalLength() / period) + 3);
        textPath.appendChild(element('animate', {
          attributeName: 'startOffset', from: 0, to: -period,
          dur: (period / 18) + 's', repeatCount: 'indefinite', calcMode: 'linear'
        }));
      }
      text.appendChild(textPath); svg.appendChild(text);
      svg.setCurrentTime(0);
      syncMotion();
    }
    function scheduleRender() {
      if (!renderFrame) renderFrame = requestAnimationFrame(render);
    }
    function onEnter(event) { if (event.pointerType === 'mouse') { hovered = true; syncMotion(); } }
    function onLeave() { hovered = false; syncMotion(); }
    host.addEventListener('pointerenter', onEnter);
    host.addEventListener('pointerleave', onLeave);
    document.addEventListener('visibilitychange', syncMotion);
    motion.addEventListener('change', scheduleRender);
    var sizeObserver = new ResizeObserver(scheduleRender);
    sizeObserver.observe(host);
    var visibilityObserver = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      headerVisible = entries[0].isIntersecting; syncMotion();
    }) : null;
    if (visibilityObserver) visibilityObserver.observe(section);
    var headerObserver = new MutationObserver(syncMotion);
    headerObserver.observe(section, { attributes: true, attributeFilter: ['class'] });
    section.querySelectorAll('details').forEach(function (details) {
      headerObserver.observe(details, { attributes: true, attributeFilter: ['open'] });
    });
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (alive) scheduleRender(); });
    current = { host: host, destroy: function () {
      alive = false; cancelAnimationFrame(renderFrame);
      sizeObserver.disconnect(); headerObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();
      document.removeEventListener('visibilitychange', syncMotion);
      motion.removeEventListener('change', scheduleRender);
      host.removeEventListener('pointerenter', onEnter); host.removeEventListener('pointerleave', onLeave);
      svg.remove(); label.remove();
    }};
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installWaveMessage, { once: true });
  else installWaveMessage();
  document.addEventListener('shopify:section:load', installWaveMessage);
})();
/* FIN PRUEBA INSTAGRAM V25 */

/* ALEGRIA V35 · apertura por raton en escritorio · 19 sep 2026 */
(function () {
  var currentNav = null;
  var cleanup = null;
  function installDesktopHover() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav || nav === currentNav) return;
    if (cleanup) cleanup();
    currentNav = nav;
    var media = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var controller = new AbortController();
    var options = { signal: controller.signal };
    var entries = Array.from(nav.querySelectorAll('header-menu')).map(function (root) {
      var details = root.querySelector(':scope > details');
      return { root: root, details: details, summary: details && details.querySelector(':scope > summary'), timer: 0, byHover: false, suppressed: false };
    }).filter(function (entry) { return entry.details && entry.summary; });
    function cancelClose(entry) { clearTimeout(entry.timer); entry.timer = 0; }
    function close(entry) {
      cancelClose(entry);
      entry.details.open = false;
      entry.summary.setAttribute('aria-expanded', 'false');
      entry.byHover = false;
    }
    entries.forEach(function (entry) {
      entry.root.addEventListener('pointerenter', function (event) {
        if (!media.matches || event.pointerType === 'touch') return;
        cancelClose(entry);
        if (entry.suppressed) return;
        entries.forEach(function (other) { if (other !== entry) close(other); });
        entry.details.open = true;
        entry.summary.setAttribute('aria-expanded', 'true');
        entry.byHover = true;
      }, options);
      entry.root.addEventListener('pointerleave', function () {
        entry.suppressed = false;
        if (!media.matches) return;
        cancelClose(entry);
        entry.timer = setTimeout(function () {
          if (!entry.root.matches(':hover') && !entry.root.contains(document.activeElement)) close(entry);
        }, 180);
      }, options);
      entry.details.addEventListener('toggle', function () {
        entry.summary.setAttribute('aria-expanded', entry.details.open ? 'true' : 'false');
        if (!entry.details.open) entry.byHover = false;
      }, options);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !media.matches) return;
      var open = entries.find(function (entry) { return entry.byHover && entry.details.open; });
      if (!open) return;
      open.suppressed = true;
      close(open);
      open.summary.focus({ preventScroll: true });
      event.preventDefault();
    }, options);
    function resetForDevice() {
      entries.forEach(function (entry) {
        cancelClose(entry);
        entry.suppressed = false;
        if (!media.matches && entry.byHover) close(entry);
      });
    }
    media.addEventListener('change', resetForDevice);
    cleanup = function () {
      entries.forEach(function (entry) { cancelClose(entry); if (entry.byHover) close(entry); });
      controller.abort();
      media.removeEventListener('change', resetForDevice);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installDesktopHover, { once: true });
  else installDesktopHover();
  document.addEventListener('shopify:section:load', installDesktopHover);
})();
/* FIN ALEGRIA V35 */

/* ALEGRIA V37 · presentación de entrega, sin cambiar el cálculo existente */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ag-delivery-terms .ag-activar');
    if (!trigger) return;
    var headerTrigger = document.querySelector('.ag-cap-cta');
    if (headerTrigger) { event.preventDefault(); headerTrigger.click(); }
  });
  function initPurchaseDetails() {
    document.querySelectorAll('product-info').forEach(function (info) {
      if (info.dataset.agPurchaseDetails) return;
      info.dataset.agPurchaseDetails = '1';
      function update() {
        var button = info.querySelector('button[name="add"]');
        var unavailable = !button || button.disabled;
        var stockWidget = info.querySelector('.pushowl-brevo-bis-form');
        var stockBlock = stockWidget && stockWidget.closest('.shopify-app-block');
        var productForm = info.querySelector('product-form');
        if (stockBlock && productForm && productForm.nextElementSibling !== stockBlock) productForm.after(stockBlock);
        var alternatives = info.querySelector('.ag-stock-alternatives');
        if (alternatives) alternatives.hidden = !unavailable;
        var delivery = info.querySelector('#ag-entrega');
        var returns = info.querySelector('.ag-product-returns');
        var terms = info.querySelector('.ag-delivery-terms');
        if (!delivery) return;
        var preorder = !!info.querySelector('.product__info-container[data-ag-preorder="true"]');
        delivery.hidden = unavailable || preorder;
        if (preorder) {
          if (terms) terms.hidden = true;
          return;
        }
        if (returns && delivery.previousElementSibling !== returns) delivery.before(returns);
        if (terms) {
          if (delivery.nextElementSibling !== terms) delivery.after(terms);
          terms.hidden = unavailable;
        }
        var date = delivery.querySelector('.ag-entrega__fecha');
        if (date && !date.querySelector('.ag-entrega__free') && date.firstChild && date.firstChild.nodeType === 3) {
          date.firstChild.textContent = 'Entrega ';
          var free = document.createElement('strong'); free.className = 'ag-entrega__free'; free.textContent = 'GRATIS';
          date.firstChild.after(free); free.after(document.createTextNode('* el '));
        }
        var estimate = delivery.querySelector('.ag-entrega__nota');
        if (estimate && estimate.textContent !== 'Fecha estimada en Península.') estimate.textContent = 'Fecha estimada en Península.';
        var sub = delivery.querySelector('.ag-entrega__sub');
        if (sub && sub.firstChild && sub.firstChild.nodeType === 3 && sub.firstChild.textContent !== 'Haz el pedido en ') sub.firstChild.textContent = 'Haz el pedido en ';
        var clock = delivery.querySelector('.ag-entrega__reloj');
        if (clock) {
          var readable = clock.textContent.replace(/\s+\d+\s*s\s*$/, '').replace(/\bh\b/g, 'horas').replace(/\bmin\b/g, 'mins');
          if (clock.textContent !== readable) clock.textContent = readable;
        }
        info.classList.add('ag-purchase-enhanced');
      }
      update();
      new MutationObserver(update).observe(info, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPurchaseDetails); else initPurchaseDetails();
  document.addEventListener('shopify:section:load', initPurchaseDetails);
})();

/* ALEGRIA V39 · formulario nativo de reposicion integrado en la ficha */
(function () {
  var attempted = new WeakSet();
  var openingInfo = null;
  var scheduled = false;
  function restockConfirmed(widget) {
    return Array.from(widget.children).some(function (node) { return node.tagName !== 'STYLE' && /Te avisaremos por email cuando este producto vuelva/.test(node.textContent); });
  }
  function updateInlineRestock() {
    scheduled = false;
    document.querySelectorAll('product-info').forEach(function (info) {
      var buy = info.querySelector('product-form button[name="add"]');
      var widget = info.querySelector('.pushowl-brevo-bis-form');
      if (!buy || !widget) return;
      var host = document.getElementById('pushowl-bis-shadow-host');
      var form = host && host.querySelector('.pushowl-bis-form-container');
      if (!buy.disabled) {
        info.classList.remove('ag-restock-inline');
        var dismiss = form && widget.contains(host) && form.querySelector('.pushowl-optin-dismiss-button');
        if (dismiss) dismiss.click();
        return;
      }
      if (form && (openingInfo === info || widget.contains(host))) {
        if (!widget.contains(host)) widget.appendChild(host);
        info.classList.add('ag-restock-inline');
        document.documentElement.classList.remove('ag-restock-preparing');
        var text = form.querySelector('button[type="submit"] .button-content');
        if (text && text.textContent.trim() === 'Avisadme') text.textContent = 'Avísame';
        return;
      }
      if (restockConfirmed(widget)) {
        info.classList.add('ag-restock-inline');
        document.documentElement.classList.remove('ag-restock-preparing');
        return;
      }
      info.classList.remove('ag-restock-inline');
      var trigger = widget.querySelector('button[name="trigger"]');
      if (!trigger || attempted.has(trigger) || getComputedStyle(widget).display === 'none') return;
      attempted.add(trigger);
      openingInfo = info;
      document.documentElement.classList.add('ag-restock-preparing');
      trigger.click();
      schedule();
      setTimeout(function () {
        document.documentElement.classList.remove('ag-restock-preparing');
        if (!widget.querySelector('.pushowl-bis-form-container') && !restockConfirmed(widget)) info.classList.remove('ag-restock-inline');
      }, 3000);
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateInlineRestock);
  }
  function install() {
    if (!document.querySelector('product-info')) return;
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return (target && target.closest('product-info, #pushowl-bis-shadow-host')) || Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && node.id === 'pushowl-bis-shadow-host'; });
      })) schedule();
    }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, {once:true}); else install();
})();

/* ALEGRIA V40 · combinacion movil, con recomendaciones Shopify y total real */
(function () {
  var mobile = window.matchMedia('(max-width: 749px)');
  var originalAddLabel = window.variantStrings && window.variantStrings.addToCart;
  function syncNativeLabel() { if (originalAddLabel && window.variantStrings) window.variantStrings.addToCart = mobile.matches ? 'Añadir a la cesta' : originalAddLabel; }
  syncNativeLabel();
  mobile.addEventListener('change', syncNativeLabel);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  /* V53: curated complements by use and style; no order-value ceiling. */
  var comboPlans = {};
  [
  {
    "products": [
      "jarron-goldfish"
    ],
    "slots": [
      [
        "cuenco-moteado-efecto-leopardo",
        "vela-balloon-dog-rosa",
        "portavelas-de-ceramica-bow-pequeno"
      ]
    ],
    "note": "Pequeños detalles para completar tu rincón."
  },
  {
    "products": [
      "jarron-paloma"
    ],
    "slots": [
      [
        "alhajero-rosa-gato-sonador",
        "alhajero-rosa-gato-sonador-copy",
        "portavelas-de-ceramica-bow-pequeno"
      ]
    ],
    "note": "Un pequeño rincón con personalidad."
  },
  {
    "products": [
      "set-de-2-sujetalibros-cowboy",
      "pack-de-2-soportes-abstractos-para-libros"
    ],
    "slots": [
      [
        "marcapaginas-vivello-pack-4",
        "marcapaginas-vivello-pack-2",
        "libreta-tulipan-azul-a5"
      ]
    ],
    "note": "Para acompañar tus lecturas."
  },
  {
    "products": [
      "collar-wild-love-3-colores"
    ],
    "slots": [
      [
        "pinza-arc-cheetah",
        "pinza-crush-cheetah"
      ],
      [
        "cuenco-moteado-efecto-leopardo",
        "alhajero-rosa-gato-sonador"
      ]
    ],
    "note": "Accesorios con carácter y un lugar donde dejarlos."
  },
  {
    "products": [
      "collar-totem-2-colores"
    ],
    "slots": [
      [
        "cuenco-moteado-efecto-leopardo",
        "alhajero-rosa-gato-sonador",
        "alhajero-rosa-gato-sonador-copy"
      ]
    ],
    "note": "Un lugar bonito para tus pequeños tesoros."
  },
  {
    "products": [
      "salero-y-pimentero-teckel-fluid-market-x-thomas-gravereau"
    ],
    "slots": [
      [
        "dispensador-de-jabon-teckel",
        "snake-trivet-green"
      ]
    ],
    "note": "Pequeños detalles para una cocina con personalidad."
  },
  {
    "products": [
      "dispensador-de-jabon-teckel",
      "jarron-teckel-fluid-market-x-thomas-gravereau"
    ],
    "slots": [
      [
        "salero-y-pimentero-teckel-fluid-market-x-thomas-gravereau"
      ]
    ],
    "note": "Para quienes tienen debilidad por los teckels."
  },
  {
    "products": [
      "salero-y-pimentero-olivia"
    ],
    "slots": [
      [
        "bandeja-de-ceramica-olivia"
      ],
      [
        "vela-aceitunas-con",
        "vela-aceituna"
      ]
    ],
    "note": "Detalles de inspiración mediterránea."
  },
  {
    "products": [
      "bandeja-de-ceramica-olivia"
    ],
    "slots": [
      [
        "salero-y-pimentero-olivia"
      ],
      [
        "vela-aceitunas-con",
        "vela-aceituna"
      ]
    ],
    "note": "Detalles de inspiración mediterránea."
  },
  {
    "products": [
      "vela-aceitunas-con",
      "vela-aceituna"
    ],
    "slots": [
      [
        "bandeja-de-ceramica-olivia",
        "salero-y-pimentero-olivia"
      ]
    ],
    "note": "Una pequeña selección de inspiración mediterránea."
  },
  {
    "products": [
      "taza-blumen",
      "taza-blomma-4-colores"
    ],
    "slots": [
      [
        "taza-blossom-3-colores",
        "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune",
        "taza-blumi-3-colores"
      ]
    ],
    "note": "Cerámica artesanal para compartir el café."
  },
  {
    "products": [
      "taza-blossom-3-colores"
    ],
    "slots": [
      [
        "taza-blumi-3-colores",
        "taza-blumen"
      ],
      [
        "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune"
      ]
    ],
    "note": "Cerámica artesanal para tu momento de café."
  },
  {
    "products": [
      "taza-blumi-3-colores"
    ],
    "slots": [
      [
        "taza-blossom-3-colores",
        "taza-blumen"
      ],
      [
        "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune"
      ]
    ],
    "note": "Cerámica artesanal para tu momento de café."
  },
  {
    "products": [
      "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune"
    ],
    "slots": [
      [
        "taza-blossom-3-colores",
        "taza-blumi-3-colores",
        "taza-blumen"
      ]
    ],
    "note": "Cerámica artesanal para tu momento de café."
  },
  {
    "products": [
      "abrebotellas-futbolin"
    ],
    "slots": [
      [
        "salero-y-pimentero-bolos",
        "snake-trivet-green"
      ]
    ],
    "note": "Detalles de mesa para recibir a los tuyos."
  },
  {
    "products": [
      "salero-y-pimentero-bolos"
    ],
    "slots": [
      [
        "abrebotellas-futbolin"
      ]
    ],
    "note": "Para tu próximo aperitivo entre amigos."
  },
  {
    "products": [
      "taza-oso-de-peluche",
      "jarron-oso-de-peluche"
    ],
    "slots": [
      [
        "salero-y-pimentero-osos-de-peluche",
        "portavelas-de-ceramica-bow-pequeno"
      ]
    ],
    "note": "Pequeños detalles para un rincón con encanto."
  },
  {
    "products": [
      "salero-y-pimentero-osos-de-peluche"
    ],
    "slots": [
      [
        "taza-oso-de-peluche",
        "jarron-oso-de-peluche"
      ]
    ],
    "note": "Una pareja de osos para tu mesa."
  },
  {
    "products": [
      "luz-nocturna-seta-disco"
    ],
    "slots": [
      [
        "jarron-seta-disco",
        "jarron-seta-disco-20-cm"
      ]
    ],
    "note": "Luz y flores con destellos disco."
  },
  {
    "products": [
      "jarron-seta-disco",
      "jarron-seta-disco-20-cm",
      "jarron-santiag-disco"
    ],
    "slots": [
      [
        "luz-nocturna-seta-disco",
        "vela-balloon-dog-rosa"
      ]
    ],
    "note": "Un rincón lleno de luz y personalidad."
  },
  {
    "products": [
      "jarron-pasta",
      "jarron-guisantes",
      "jarron-cereza"
    ],
    "slots": [
      [
        "bandeja-de-ceramica-dolce-vita-tomate",
        "bandeja-de-ceramica-olivia",
        "candelabro-dolce-vita-farfalle"
      ]
    ],
    "note": "Pequeños detalles de inspiración gastronómica."
  },
  {
    "products": [
      "libreta-tulipan-verde-a5-copy",
      "libreta-tulipan-rosa-a5",
      "libreta-tulipan-azul-a5",
      "organizador-semanal-gris",
      "calendario-vertical-full-color",
      "calendario-pequeno-full-color-glossy-copy"
    ],
    "slots": [
      [
        "marcapaginas-vivello-pack-2",
        "libreta-tulipan-azul-a5",
        "organizador-semanal-gris"
      ]
    ],
    "note": "Color para tus ideas de cada día."
  },
  {
    "products": [
      "marcapaginas-vivello-pack-2",
      "marcapaginas-vivello-pack-4"
    ],
    "slots": [
      [
        "libreta-tulipan-azul-a5",
        "libreta-tulipan-verde-a5-copy",
        "libreta-tulipan-rosa-a5"
      ]
    ],
    "note": "Para tus lecturas, notas e ideas."
  },
  {
    "products": [
      "pinza-lib-cheetah",
      "paw-cheetah",
      "pinza-arc-cheetah",
      "pinza-crush-cheetah"
    ],
    "slots": [
      [
        "cuenco-moteado-efecto-leopardo",
        "alhajero-rosa-gato-sonador"
      ]
    ],
    "note": "Un lugar para dejar tus accesorios."
  },
  {
    "products": [
      "prendedor-croissant",
      "prendedor-croissant-copy",
      "prendedor-pimiento",
      "prendedor-oso-de-peluche",
      "prendedor-pigeon",
      "paw-soft-violet"
    ],
    "slots": [
      [
        "alhajero-rosa-gato-sonador",
        "alhajero-rosa-gato-sonador-copy",
        "cuenco-moteado-efecto-leopardo"
      ]
    ],
    "note": "Un lugar para dejar tus accesorios."
  },
  {
    "products": [
      "abanico-estrella-polar",
      "abanico-nyc",
      "abanico-brisa-escarlata",
      "abanico-floral"
    ],
    "slots": [
      [
        "pinza-lib-cheetah",
        "paw-soft-violet"
      ]
    ],
    "note": "Pequeños accesorios para llevar contigo."
  },
  {
    "products": [
      "calcetines-love-flat",
      "calcetines-flat-tulip",
      "calcetines-slow-days",
      "calcetines-cry-club",
      "calcetines-try-later",
      "calcetines-fizzy-bubbles-packaging-3d"
    ],
    "slots": [
      [
        "prendedor-croissant",
        "prendedor-oso-de-peluche",
        "prendedor-pigeon"
      ]
    ],
    "note": "Pequeños accesorios para un regalo con personalidad."
  },
  {
    "products": [
      "reloj-carey-canela",
      "reloj-bubble-gum",
      "reloj-smoothie-verde",
      "reloj-disco",
      "reloj-banana-haven",
      "reloj-campo-de-lavanda",
      "reloj-tulipanes",
      "reloj-sunburn"
    ],
    "slots": [
      [
        "cuenco-moteado-efecto-leopardo",
        "alhajero-rosa-gato-sonador",
        "alhajero-rosa-gato-sonador-copy"
      ]
    ],
    "note": "Un lugar para dejar tu reloj al terminar el día."
  },
  {
    "products": [
      "gorra-silly-flower-verde",
      "casquette-vintage-fleur-souriante-bleuet",
      "casquette-vintage-cerises",
      "casquette-vintage-fleur-souriante-orange",
      "casquette-vintage-fleur-sur-fesses-rose-vert"
    ],
    "slots": [
      [
        "calcetines-flat-tulip",
        "calcetines-love-flat"
      ]
    ],
    "note": "Accesorios para dar color a tu día a día."
  },
  {
    "products": [
      "bolso-de-toalla-paseo",
      "bolso-de-toalla-poppy"
    ],
    "slots": [
      [
        "abanico-floral",
        "abanico-nyc",
        "pinza-lib-cheetah"
      ]
    ],
    "note": "Pequeños compañeros para tus paseos."
  },
  {
    "products": [
      "lucky-cat-mini-avara-edicion-limitada",
      "lucky-cat-lila",
      "lucky-cat-moonlight-1",
      "lucky-cat-ocre",
      "lucky-cat-amarillo-profundo",
      "lucky-cat-melocoton"
    ],
    "slots": [
      [
        "calendario-vertical-full-color",
        "calendario-pequeno-full-color-glossy-copy"
      ]
    ],
    "note": "Un toque alegre para tu escritorio."
  },
  {
    "products": [
      "lampara-shroom",
      "lampara-wavy-shell"
    ],
    "slots": [
      [
        "alhajero-rosa-gato-sonador",
        "cuenco-moteado-efecto-leopardo"
      ]
    ],
    "note": "Luz y pequeños detalles para tu rincón favorito."
  },
  {
    "products": [
      "lamina-jean-jullien-botella",
      "lamina-jean-jullien-botella-copy",
      "lamina-sunny-wu-aperitivos-de-medianoche-copy",
      "lamina-manon-diemer-en-ningun-lugar-de-marruecos",
      "lamina-liam-cobb-en-ninguna-parte-de-japon",
      "lamina-maria-medem-1",
      "lamina-simon-bailly-si-no-tienes-cocina-usa-una-pickup"
    ],
    "slots": [
      [
        "florero-koral-small",
        "jarron-bloom-pequeno"
      ]
    ],
    "note": "Arte y flores para dar vida a tu rincón."
  },
  {
    "products": [
      "cuenco-moteado-efecto-leopardo"
    ],
    "slots": [
      [
        "servicio-de-noche-moteado-efecto-leopardo"
      ]
    ],
    "note": "Vidrio moteado para completar tu rincón."
  },
  {
    "products": [
      "servicio-de-noche-moteado-efecto-leopardo"
    ],
    "slots": [
      [
        "cuenco-moteado-efecto-leopardo"
      ]
    ],
    "note": "Vidrio moteado para completar tu rincón."
  },
  {
    "products": [
      "alhajero-rosa-gato-sonador",
      "alhajero-rosa-gato-sonador-copy"
    ],
    "slots": [
      [
        "prendedor-pigeon",
        "prendedor-oso-de-peluche",
        "paw-soft-violet"
      ]
    ],
    "note": "Pequeños accesorios para guardar aquí."
  },
  {
    "products": [
      "cajita-decorativa-globo-corazon"
    ],
    "slots": [
      [
        "collar-wild-love-3-colores",
        "collar-totem-2-colores"
      ]
    ],
    "note": "Un regalo con corazón y un lugar para guardarlo."
  },
  {
    "products": [
      "vaciabolsillos-tenis"
    ],
    "slots": [
      [
        "vela-pelota-de-tenis"
      ]
    ],
    "note": "Para quienes disfrutan dentro y fuera de la pista."
  },
  {
    "products": [
      "vela-pelota-de-tenis"
    ],
    "slots": [
      [
        "vaciabolsillos-tenis"
      ]
    ],
    "note": "Detalles para amantes del tenis."
  },
  {
    "products": [
      "vela-bola-8-de-billar"
    ],
    "slots": [
      [
        "abrebotellas-futbolin"
      ]
    ],
    "note": "Un toque de juego para tu próximo encuentro."
  },
  {
    "products": [
      "taza-gato"
    ],
    "slots": [
      [
        "alhajero-rosa-gato-sonador",
        "alhajero-rosa-gato-sonador-copy"
      ]
    ],
    "note": "Pequeños detalles para amantes de los gatos."
  },
  {
    "products": [
      "vela-balloon-dog-rosa",
      "vela-balloon-dog-azul",
      "vela-balloon-dog-verde",
      "vela-balloon-dog-violeta",
      "vela-balloon-dog-magenta",
      "vela-balloon-dog-sevilla",
      "vela-balloon-dog-yokohama"
    ],
    "slots": [
      [
        "caja-de-almacenamiento-venus-roja",
        "alhajero-rosa-gato-sonador"
      ]
    ],
    "note": "Piezas decorativas para un rincón con carácter."
  },
  {
    "products": [
      "vela-fusilli",
      "vela-rigatoni",
      "vela-penne",
      "vela-tomate-maduro"
    ],
    "slots": [
      [
        "bandeja-de-ceramica-dolce-vita-tomate",
        "bandeja-de-ceramica-olivia"
      ]
    ],
    "note": "Detalles decorativos de inspiración gastronómica."
  },
  {
    "products": [
      "bandeja-de-ceramica-dolce-vita-tomate"
    ],
    "slots": [
      [
        "vela-tomate-maduro",
        "candelabro-dolce-vita-farfalle"
      ]
    ],
    "note": "Detalles decorativos de inspiración gastronómica."
  },
  {
    "products": [
      "portavelas-de-ceramica-bow-pequeno",
      "candelabro-de-ceramica-amanita",
      "candelabro-dolce-vita-farfalle"
    ],
    "slots": [
      [
        "jarron-amanita-pequeno",
        "florero-koral-small"
      ]
    ],
    "note": "Flores y pequeños detalles para decorar juntos."
  },
  {
    "products": [
      "jarron-trofeo-de-ceramica-partner-in-life",
      "jarron-trofeo-de-ceramica-best-friend-award",
      "jarron-trofeo-de-ceramica-mejor-madre-del-mundo",
      "jarron-trofeo-de-ceramica-mejor-padre-del-mundo"
    ],
    "slots": [
      [
        "calcetines-love-flat",
        "calcetines-flat-tulip"
      ]
    ],
    "note": "Un detalle más para esa persona especial."
  },
  {
    "products": [
      "jarron-amanita-pequeno",
      "florero-koral-small",
      "macetero-botas-de-lluvia",
      "jarron-bota-de-lluvia-con-lunares",
      "jarron-bloom-pequeno",
      "jarron-cottage",
      "florero-koral-medium",
      "macetero-sirena",
      "jarron-orange-juice",
      "jarron-leche",
      "jarron-amanita-grande",
      "jarron-farmers-market-banana",
      "jarron-rainbow",
      "jarron-bretzel",
      "jarron-bolsa",
      "jarron-corazon",
      "macetero-jarron-ramen",
      "florero-koral-large"
    ],
    "slots": [
      [
        "bandeja-de-ceramica-olivia",
        "alhajero-rosa-gato-sonador",
        "cuenco-moteado-efecto-leopardo"
      ]
    ],
    "note": "Flores y un lugar para los pequeños objetos."
  },
  {
    "products": [
      "caja-de-almacenamiento-venus-roja",
      "the-finger-sculpture-rainbow"
    ],
    "slots": [
      [
        "vela-balloon-dog-rosa",
        "vela-balloon-dog-violeta"
      ]
    ],
    "note": "Formas y color para un rincón con carácter."
  },
  {
    "products": [
      "taza-de-ceramica-verde",
      "taza-de-cristal-zafiro-1",
      "taza-limone",
      "taza-fresa",
      "taza-croissant",
      "taza-pasta",
      "taza-cereza",
      "taza-mandarina",
      "taza-banana",
      "taza-berenjena"
    ],
    "slots": [
      [
        "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune",
        "cuenco-moteado-efecto-leopardo"
      ]
    ],
    "note": "Para acompañar tu momento de café."
  },
  {
    "products": [
      "salero-y-pimentero-ketchup-mostaza",
      "salero-y-pimentero-hamburguesa-patatas-fritas"
    ],
    "slots": [
      [
        "taza-croissant",
        "taza-banana"
      ]
    ],
    "note": "Una mesa con un toque divertido."
  },
  {
    "products": [
      "salero-y-pimentero-dolce-vita-farfalle-macaroni",
      "amanita-salt-and-pepper",
      "salero-y-pimentero-juice",
      "salero-y-pimentero-banana-cereza",
      "salero-y-pimentero-naranja-y-pera"
    ],
    "slots": [
      [
        "snake-trivet-green",
        "assiette-en-ceramique-en-forme-de-fleur-faite-a-la-main-fabriquee-en-espagne-bord-jaune"
      ]
    ],
    "note": "Pequeños detalles para completar tu mesa."
  },
  {
    "products": [
      "abrebotellas-banana"
    ],
    "slots": [
      [
        "salero-y-pimentero-banana-cereza",
        "salero-y-pimentero-naranja-y-pera"
      ]
    ],
    "note": "Frutas y color para tu próximo aperitivo."
  },
  {
    "products": [
      "snake-trivet-green"
    ],
    "slots": [
      [
        "salero-y-pimentero-teckel-fluid-market-x-thomas-gravereau",
        "salero-y-pimentero-olivia"
      ]
    ],
    "note": "Piezas útiles para una mesa con personalidad."
  },
  {
    "products": [
      "fast-food-trinket-tray-fried-egg"
    ],
    "slots": [
      [
        "vela-aceitunas-con",
        "vela-tomate-maduro"
      ]
    ],
    "note": "Un rincón decorativo con mucho sabor."
  },
  {
    "products": [
      "platos-verduras-set-de-4"
    ],
    "slots": [
      [
        "salero-y-pimentero-banana-cereza",
        "salero-y-pimentero-naranja-y-pera"
      ]
    ],
    "note": "Frutas y verduras para vestir tu mesa."
  },
  {
    "products": [
      "amalfi-coasters-set-de-4"
    ],
    "slots": [
      [
        "manteles-individuales-amalfi-set-de-2",
        "taza-blossom-3-colores"
      ]
    ],
    "note": "Piezas para vestir tu mesa."
  },
  {
    "products": [
      "manteles-individuales-amalfi-set-de-2"
    ],
    "slots": [
      [
        "amalfi-coasters-set-de-4",
        "salero-y-pimentero-olivia"
      ]
    ],
    "note": "Piezas para vestir tu mesa."
  },
  {
    "products": [
      "basket-sicilia-small-light-blue",
      "templo-high-tray-dark-blue"
    ],
    "slots": [
      [
        "florero-koral-small",
        "jarron-bloom-pequeno"
      ]
    ],
    "note": "Formas y color para completar tu rincón."
  },
  {
    "products": [
      "bowl-baloncesto"
    ],
    "slots": [
      [
        "abrebotellas-futbolin",
        "salero-y-pimentero-bolos"
      ]
    ],
    "note": "Un toque de juego en tu mesa."
  }
].forEach(function (plan) { plan.products.forEach(function (handle) { comboPlans[handle] = plan; }); });
  function simpleExtraVariant(v) {
    var rule = v.quantity_rule || {}, min = Number(rule.min) || 1, step = Number(rule.increment) || 1;
    return v.available && min <= 1 && (!rule.max || Number(rule.max) >= 1) && (1 - min) % step === 0 && !v.requires_selling_plan;
  }
  function init(info) {
    if (info.dataset.agMobileProduct) return;
    info.dataset.agMobileProduct = '1';
    var block = info.querySelector('.ag-mobile-combo');
    var dataNode = block && block.querySelector('.ag-mobile-combo__data');
    var main;
    try { main = dataNode && JSON.parse(dataNode.textContent); } catch (e) { return; }
    var cards = [], loaded = false, busy = false, scheduled = false;
    var itemsBox = block && block.querySelector('.ag-mobile-combo__items');
    var add = block && block.querySelector('.ag-mobile-combo__add');
    var status = block && block.querySelector('.ag-mobile-combo__status');
    var currency = block ? block.dataset.currency : 'EUR';
    function money(cents) { return new Intl.NumberFormat('es-ES', { style:'currency', currency:currency || 'EUR' }).format(cents / 100); }
    function buy() { return info.querySelector('product-form button[name="add"]'); }
    function variant() {
      var input = info.querySelector('product-form input[name="id"]');
      return main && main.variants.find(function (v) { return String(v.id) === String(input && input.value); });
    }
    function quantity() {
      var input = info.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }
    function makeCard(product, isMain) {
      var variants = product.variants.filter(function (v) { return isMain ? v.available : simpleExtraVariant(v); });
      if (!isMain && !variants.length) return null;
      var current = isMain ? variant() : variants[0];
      if (!current) return null;
      var card = document.createElement('div'); card.className = 'ag-mobile-combo__item';
      var link = document.createElement('a'); link.className = 'ag-mobile-combo__image'; link.href = product.url || root + 'products/' + product.handle;
      var image = document.createElement('img'); image.src = product.image || product.featured_image; image.alt = product.title; image.loading = 'lazy'; image.width = 250; image.height = 250; link.appendChild(image); card.appendChild(link);
      var label = document.createElement('label'); label.className = 'ag-mobile-combo__label';
      var check = document.createElement('input'); check.type = 'checkbox'; check.checked = isMain || (cards.length === 1 && variants.length === 1); check.disabled = isMain; check.setAttribute('aria-label', (isMain ? 'Producto principal: ' : 'Incluir ') + product.title);
      var name = document.createElement('span'); name.textContent = product.title; label.append(check, name); card.appendChild(label);
      var price = document.createElement('span'); price.className = 'ag-mobile-combo__price'; price.textContent = money(current.price); card.appendChild(price);
      var select = null;
      if (!isMain && variants.length > 1) {
        select = document.createElement('select'); select.className = 'ag-mobile-combo__variant'; select.setAttribute('aria-label', 'Elige una opcion de ' + product.title);
        var placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = 'Elige una opción'; select.appendChild(placeholder);
        variants.forEach(function (v) { var option = document.createElement('option'); option.value = v.id; option.textContent = v.title; select.appendChild(option); });
        card.appendChild(select);
      }
      var qty = document.createElement('small'); qty.className = 'ag-mobile-combo__qty'; card.appendChild(qty);
      var item = { product:product, main:isMain, check:check, select:select, price:price, qty:qty, variant:isMain || variants.length === 1 ? current : null }; 
      check.addEventListener('change', sync);
      if (select) select.addEventListener('change', function () { item.variant = variants.find(function (v) { return String(v.id) === select.value; }) || null; item.check.checked = !!item.variant; sync(); });
      itemsBox.appendChild(card); cards.push(item); return item;
    }
    function syncDescription() {
      var source = info.querySelector('.ag-gancho');
      var target = info.querySelector('.ag-mobile-product-details .rte');
      if (source && target && source.innerHTML.trim() && target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
    }
    function syncRelated() {
      var excluded = new Set();
      if (mobile.matches && block && !block.hidden) cards.forEach(function (item) { excluded.add(String(item.product.id)); });
      document.querySelectorAll('product-recommendations.related-products[data-ag-related-limit]').forEach(function (section) {
        if (main && section.dataset.productId !== String(main.id)) return;
        var items = Array.from(section.querySelectorAll('[data-ag-related-product]'));
        if (!items.length) return;
        var shown = 0, limit = parseInt(section.dataset.agRelatedLimit, 10) || 4;
        items.forEach(function (item) {
          var show = !excluded.has(item.dataset.agRelatedProduct) && shown < limit;
          if (show) shown++;
          if (item.hidden === show) item.hidden = !show;
        });
        section.hidden = shown === 0;
      });
    }
    function sync() {
      scheduled = false;
      syncDescription();
      var button = buy();
      if (!button) return;
      var unavailable = button.disabled;
      info.classList.toggle('ag-mobile-unavailable', unavailable);
      var label = button.querySelector('span');
      if (!unavailable && label) {
        if (mobile.matches && /^(Anadir|Añadir|Agregar) (al carrito|a la cesta)$/.test(label.textContent.trim())) text(label, 'Añadir a la cesta');
        else if (!mobile.matches && label.textContent.trim() === 'Añadir a la cesta') text(label, (window.variantStrings && window.variantStrings.addToCart) || 'Añadir al carrito');
      }
      if (!block || !main) return;
      var selected = variant();
      var available = !unavailable && selected && selected.available;
      block.hidden = !mobile.matches || !available || cards.length < 2;
      syncRelated();
      if (!available || !cards.length) return;
      var total = 0, count = 0, checked = 0, needsChoice = false;
      cards.forEach(function (item) {
        if (item.main) item.variant = selected;
        var units = item.main ? quantity() : 1;
        var displayPrice = item.variant ? item.variant.price : Math.min.apply(null, item.product.variants.filter(simpleExtraVariant).map(function (v) { return v.price; }));
        text(item.price, (item.variant ? '' : 'Desde ') + money(displayPrice * units));
        text(item.qty, item.main ? 'Este producto · ' + units + (units === 1 ? ' unidad' : ' unidades') : '');
        if (item.main || item.check.checked) { if (!item.variant) { needsChoice = true; return; } total += item.variant.price * units; count += units; checked++; }
      });
      if (!busy) {
        var cannotAdd = checked < 2 || needsChoice;
        if (add.disabled !== cannotAdd) add.disabled = cannotAdd;
        text(add, needsChoice ? 'Elige una opción del complemento' : checked < 2 ? 'Elige otra pieza para combinar' : 'Añadir conjunto\n' + money(total));
      }
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } }
    async function recommendations() {
      if (!block || !main || loaded || !mobile.matches) return;
      loaded = true;
      try {
        var handle = (main.url || '').split('?')[0].split('/').filter(Boolean).pop();
        var plan = comboPlans[handle];
        var cartPromise = fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        var products = [];
        if (plan) {
          var handles = Array.from(new Set([].concat.apply([], plan.slots)));
          products = await Promise.all(handles.map(function (candidate) {
            return fetch(root + 'products/' + candidate + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          }));
        } else {
          var response = await fetch(root + 'recommendations/products.json?product_id=' + main.id + '&limit=10&intent=complementary');
          if (response.ok) products = (await response.json()).products || [];
        }
        var cart = await cartPromise;
        var seen = new Set([String(main.id)]);
        if (cart && Array.isArray(cart.items)) cart.items.forEach(function (item) { seen.add(String(item.product_id)); });
        function eligible(p) { return p && !seen.has(String(p.id)) && p.available && !p.requires_selling_plan && Array.isArray(p.variants) && p.variants.some(simpleExtraVariant); }
        var chosen = [];
        if (plan) {
          plan.slots.forEach(function (slot) {
            var candidate = slot.map(function (h) { return products.find(function (p) { return p && p.handle === h; }); }).find(eligible);
            if (candidate) { chosen.push(candidate); seen.add(String(candidate.id)); }
          });
        } else {
          products.forEach(function (p) { if (chosen.length < 2 && eligible(p)) { chosen.push(p); seen.add(String(p.id)); } });
        }
        cards = []; itemsBox.replaceChildren();
        text(block.querySelector('.ag-mobile-combo__intro'), plan ? plan.note : 'Piezas que quedan bien juntas. Elige las tuyas.');
        if (chosen.length && makeCard(main, true)) chosen.forEach(function (p) { makeCard(p, false); });
        sync();
      } catch (e) { block.hidden = true; syncRelated(); }
    }
    if (add) add.addEventListener('click', async function () {
      if (busy || add.disabled || info.dataset.agPurchaseBusy) return;
      var quantityInput = info.querySelector('input[name="quantity"]');
      if (quantityInput && !quantityInput.reportValidity()) return;
      var selected = variant();
      if (!selected || !selected.available || buy().disabled) return;
      if (cards.some(function (item) { return !item.main && item.check.checked && (!item.variant || !simpleExtraVariant(item.variant)); })) return;
      var items = cards.filter(function (item) { return item.main || item.check.checked; }).map(function (item) { return { id:item.main ? selected.id : item.variant.id, quantity:item.main ? quantity() : 1 }; });
      if (items.length < 2) return;
      info.dataset.agPurchaseBusy = 'combo';
      busy = true; add.disabled = true; add.setAttribute('aria-busy','true'); text(add, 'Añadiendo a tu cesta…'); text(status, '');
      var comboAddAttempted = false;
      try {
        if (window.agPrepareProductGift) await window.agPrepareProductGift(info);
        comboAddAttempted = true;
        var response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        var result = await response.json();
        if (!response.ok || result.status) throw new Error('cart');
        text(add, 'Ya están en tu cesta');
        window.location.assign((window.routes && window.routes.cart_url) || root + 'cart');
      } catch (e) {
        if (!comboAddAttempted) {
          busy = false; delete info.dataset.agPurchaseBusy; add.removeAttribute('aria-busy'); sync();
          text(status, e.message || 'No hemos podido guardar la tarjeta. Inténtalo de nuevo.'); return;
        }
        text(add, 'Revisa tu cesta');
        text(status, 'No hemos podido confirmar el conjunto. Revisa tu cesta antes de volver a intentarlo. ');
        var link = document.createElement('a'); link.href = (window.routes && window.routes.cart_url) || root + 'cart'; link.textContent = 'Ver mi cesta'; status.appendChild(link);
        add.removeAttribute('aria-busy');
      }
    });
    document.querySelectorAll('product-recommendations.related-products[data-ag-related-limit]').forEach(function (section) {
      new MutationObserver(syncRelated).observe(section, {childList:true,subtree:true});
    });
    info.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(info,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
    mobile.addEventListener('change',function(){sync();recommendations();});
    window.addEventListener('pageshow', function (event) { if (event.persisted) { loaded = false; recommendations(); } });
    sync(); recommendations();
  }
  function install() { document.querySelectorAll('product-info').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, {once:true}); else install();
  document.addEventListener('shopify:section:load',install);
})();

/* ALEGRIA V42 · compra directa al checkout general, sin elegir una wallet */
(function () {
  var mobile = window.matchMedia('(max-width:749px)');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var giftStates = new WeakMap();
  function initGift(info) {
    if (!info) return null;
    if (giftStates.has(info)) return giftStates.get(info);
    var box = info.querySelector('.ag-product-gift');
    if (!box) return null;
    var check = box.querySelector('input[type="checkbox"]');
    var field = box.querySelector('textarea');
    var message = box.querySelector('.ag-product-gift__message');
    var state = {check:check, field:field, dirty:false, pending:null};
    check.addEventListener('change', function () {
      message.hidden = !check.checked; field.required = check.checked;
      field.setCustomValidity(check.checked && !field.value.trim() ? 'Escribe el mensaje para tu tarjeta o desmarca la opción de regalo.' : '');
      state.dirty = true;
      if (check.checked) field.focus();
    });
    field.addEventListener('input', function () { state.dirty = true; field.setCustomValidity(check.checked && !field.value.trim() ? 'Escribe el mensaje para tu tarjeta o desmarca la opción de regalo.' : ''); });
    field.required = check.checked;
    giftStates.set(info, state);
    return state;
  }
  window.agPrepareProductGift = async function (info) {
    var state = initGift(info);
    if (!state || !mobile.matches || !state.dirty) return;
    if (state.pending) return state.pending;
    var note = state.check.checked ? state.field.value.trim() : '';
    if (state.check.checked && !note) {
      state.field.setCustomValidity('Escribe el mensaje para tu tarjeta o desmarca la opción de regalo.');
      state.field.reportValidity();
      throw new Error('Escribe el mensaje para tu tarjeta o desmarca la opción de regalo.');
    }
    state.pending = (async function () {
      try {
        var response = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({note:note})});
        if (!response.ok) throw new Error('note');
        var cart = await response.json();
        if ((cart.note || '') !== note) throw new Error('note');
        state.dirty = false;
      } catch (error) {
        throw new Error('No hemos podido guardar tu tarjeta. Inténtalo de nuevo antes de continuar.');
      } finally { state.pending = null; }
    })();
    return state.pending;
  };
  function checkout() {
    var form = document.createElement('form');
    form.method = 'post'; form.action = (window.routes && window.routes.cart_url) || root + 'cart'; form.hidden = true;
    var submit = document.createElement('input'); submit.type = 'hidden'; submit.name = 'checkout'; submit.value = '1';
    form.appendChild(submit); document.body.appendChild(form); form.submit();
  }
  function install(info) {
    if (info.dataset.agDirectCheckout) return;
    var button = info.querySelector('.ag-buy-now');
    var form = info.querySelector('product-form form');
    var native = form && form.querySelector('button[name="add"]');
    var status = info.querySelector('.ag-buy-now__status');
    if (!button || !form || !native || !status) return;
    info.dataset.agDirectCheckout = '1'; initGift(info);
    var phase = 'idle';
    function sync() {
      var disabled = native.disabled || phase === 'preparing' || phase === 'uncertain' || native.getAttribute('aria-disabled') === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
    }
    function statusText(message) { status.textContent = message; }
    button.addEventListener('click', async function () {
      if (!mobile.matches || button.disabled || info.dataset.agPurchaseBusy) return;
      if (phase === 'added') { checkout(); return; }
      var quantity = info.querySelector('input[name="quantity"]');
      if (quantity && !quantity.reportValidity()) return;
      if (!form.reportValidity()) return;
      var data = new FormData(form);
      if (!data.get('id')) return;
      var selectedId = String(data.get('id'));
      phase = 'preparing'; info.dataset.agPurchaseBusy = 'direct';
      button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = 'Abriendo el pago…'; statusText('');
      var addAttempted = false;
      try {
        await window.agPrepareProductGift(info);
        addAttempted = true;
        var response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        var result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'No hemos podido confirmar la cantidad solicitada.');
        phase = 'added'; button.textContent = 'Continuar al pago'; button.removeAttribute('aria-busy');
        checkout();
      } catch (error) {
        button.removeAttribute('aria-busy');
        if (!addAttempted) {
          phase = 'idle'; delete info.dataset.agPurchaseBusy; button.textContent = 'Comprar ahora'; sync();
          statusText(error.message || 'No hemos podido guardar la tarjeta. Inténtalo de nuevo.');
          return;
        }
        phase = 'uncertain'; button.disabled = true; button.textContent = 'Revisa tu cesta';
        var message = 'No hemos podido confirmar la compra directa. Revisa tu cesta antes de volver a añadir el producto.';
        try {
          var cartResponse = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'},cache:'no-store'});
          if (cartResponse.ok) {
            var cart = await cartResponse.json();
            var count = cart.items.filter(function (item) { return String(item.variant_id) === selectedId; }).reduce(function (sum,item) { return sum + item.quantity; },0);
            message = count ? 'Tu cesta contiene ' + count + (count === 1 ? ' unidad' : ' unidades') + ' de esta opción. Revisa la cantidad antes de continuar.' : 'No se ha podido confirmar el producto en tu cesta. Revisa la disponibilidad antes de continuar.';
          }
        } catch (ignored) {}
        statusText(message + ' ');
        var link = document.createElement('a'); link.href = (window.routes && window.routes.cart_url) || root + 'cart'; link.textContent = 'Revisar mi cesta'; status.appendChild(link);
      }
    });
    info.addEventListener('change', function (event) {
      if (phase === 'added' && event.target.matches('input[name="quantity"],variant-selects input,variant-selects select')) {
        phase = 'idle'; delete info.dataset.agPurchaseBusy; button.textContent = 'Comprar ahora';
      }
      sync();
    });
    new MutationObserver(sync).observe(form, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    window.addEventListener('pageshow', function () {
      if (phase === 'added') { delete info.dataset.agPurchaseBusy; button.textContent = 'Continuar al pago'; sync(); }
    });
    sync();
  }
  function all() { document.querySelectorAll('product-info.ag-mobile-layout-v40').forEach(install); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',all,{once:true}); else all();
  document.addEventListener('shopify:section:load',all);
})();

/* ALEGRIA V43 — Quick add, preserves the customer's cart and chosen variant. */
(function () {
  if (customElements.get('ag-card-buy')) return;
  var adding = false;
  customElements.define('ag-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('form');
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('.ag-card-buy__open');
      this.status = this.querySelector('.ag-card-buy__status');
      this.select = this.querySelector('select[name="id"]');
      this.submit = this.querySelector('[type="submit"]');
      this.busy = false;
      if (this.opener && this.dialog) {
        this.opener.hidden = false;
        this.opener.addEventListener('click', () => { this.dialog.showModal(); });
        this.querySelector('.ag-card-buy__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          var box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
      }
      if (this.select) {
        this.submit.disabled = !this.select.value;
        this.select.addEventListener('change', () => {
          if (this.busy || this.uncertain) return;
          var option = this.select.options[this.select.selectedIndex];
          this.submit.disabled = !this.select.value || option.disabled;
          if (!this.select.value) return;
          this.querySelector('.ag-card-buy__price').textContent = option.dataset.price;
          var image = this.querySelector('.ag-card-buy__image');
          if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
          this.querySelector('.ag-card-buy__dialog-status').textContent = '';
        });
      }
      if (this.form) this.form.addEventListener('submit', (event) => this.add(event));
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || this.uncertain || !this.form.reportValidity()) return;
      var status = this.dialog && this.dialog.open ? this.querySelector('.ag-card-buy__dialog-status') : this.status;
      if (adding) { status.textContent = 'Estamos añadiendo el otro artículo. Vuelve a pulsar en un momento.'; return; }
      if (this.select && (!this.select.value || this.select.options[this.select.selectedIndex].disabled)) return;
      adding = true; this.busy = true; this.submit.disabled = true; this.submit.textContent = 'Añadiendo…'; status.textContent = '';
      var body = new FormData(this.form);
      body.set('sections','cart-icon-bubble');
      body.set('sections_url',window.location.pathname);
      var sent = false, confirmed = false, rejected = false;
      var cartURL = (window.routes && window.routes.cart_url) || '/cart';
      try {
        sent = true;
        var response = await fetch(this.form.action + (this.form.action.endsWith('.js') ? '' : '.js'), {
          method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:body
        });
        var data = await response.json();
        if (!response.ok || data.status) {
          rejected = false; // Shopify may partially fulfil an add even when returning a stock error.
          throw new Error(data.description || 'No hemos podido añadir este artículo. Revisa su disponibilidad.');
        }
        confirmed = true;
        try {
          var currentIcon = document.getElementById('cart-icon-bubble');
          if (currentIcon && data.sections && data.sections['cart-icon-bubble']) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');
            var newIcon = parsed.querySelector('.shopify-section');
            if (newIcon) currentIcon.innerHTML = newIcon.innerHTML;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source:'ag-card-buy',productVariantId:body.get('id'),cartData:data})).catch(function(){});
          }
        } catch (ignored) {}
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.status.textContent = 'Añadido a tu cesta. ';
        var link = document.createElement('a'); link.href = cartURL; link.textContent = 'Ver cesta'; this.status.appendChild(link);
        this.submit.textContent = 'Añadido';
        setTimeout(() => { if (this.isConnected && !this.busy && !this.uncertain) this.submit.textContent = 'Añadir a la cesta'; }, 1800);
      } catch (error) {
        this.uncertain = sent && !confirmed && !rejected;
        status.textContent = this.uncertain ? 'No hemos podido confirmar el resultado. Revisa tu cesta antes de volver a añadir. ' : error.message + ' ';
        if (this.uncertain) { var review = document.createElement('a'); review.href = cartURL; review.textContent = 'Revisar cesta'; status.appendChild(review); }
        this.submit.textContent = 'Añadir a la cesta';
      } finally {
        adding = false; this.busy = false;
        this.submit.disabled = !!this.uncertain || !!(this.select && !this.select.value);
      }
    }
  });
})();

/* ALEGRIA V60: el aviso de tarjeta usa BISFormRender del modulo PushOwl instalado. */
(function () {
 if(customElements.get('ag-card-restock')||!window.HTMLDialogElement)return;
 var dialog,mount,status,image,title,choices,chooser,fallback,active,timer,requestId=0,observer;
 function clearForm(){var host=document.getElementById('pushowl-bis-shadow-host');if(host&&mount&&mount.contains(host)){var close=host.querySelector('.pushowl-optin-dismiss-button');if(close)close.click();host.remove();}if(mount){var previous=mount;mount=document.createElement('div');mount.className='pushowl-brevo-bis-form';previous.replaceWith(mount);}}
 function placeForm(){if(!active||!dialog.open)return;var host=document.getElementById('pushowl-bis-shadow-host');var form=host&&host.querySelector('.pushowl-bis-form-container');if(form){if(!mount.contains(host))mount.appendChild(host);var label=form.querySelector('button[type="submit"] .button-content');if(label&&label.textContent.trim()==='Avisadme')label.textContent='Avísame';status.hidden=true;clearTimeout(timer);return;}if(/Te avisaremos por email cuando este producto vuelva/.test(mount.textContent)){status.hidden=true;clearTimeout(timer);return;}var trigger=mount.querySelector('button[name="trigger"]');if(trigger&&!trigger.dataset.agOpened){trigger.dataset.agOpened='1';trigger.click();}}
 function createDialog(){if(dialog)return;dialog=document.createElement('dialog');dialog.className='ag-restock-dialog ag-restock-inline';dialog.setAttribute('aria-labelledby','ag-restock-dialog-title');dialog.innerHTML='<button type="button" class="ag-card-buy__close" aria-label="Cerrar aviso de reposición">×</button><div class="ag-restock-dialog__intro"><img alt="" width="84" height="84"><div><p class="ag-restock-dialog__eyebrow">Agotado</p><h2 id="ag-restock-dialog-title"></h2></div></div><label class="ag-restock-dialog__choices" hidden>Elige la opción que quieres recibir<select><option value="">Elige una opción</option></select></label><p class="ag-restock-dialog__status" role="status">Cargando el formulario…</p><div class="pushowl-brevo-bis-form"></div><a class="ag-restock-dialog__fallback">Ver el producto</a>';document.body.appendChild(dialog);mount=dialog.querySelector('.pushowl-brevo-bis-form');status=dialog.querySelector('[role="status"]');image=dialog.querySelector('img');title=dialog.querySelector('h2');choices=dialog.querySelector('label');chooser=dialog.querySelector('select');fallback=dialog.querySelector('.ag-restock-dialog__fallback');dialog.querySelector('button').addEventListener('click',function(){dialog.close();});dialog.addEventListener('click',function(event){if(event.target!==dialog)return;var b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();});dialog.addEventListener('close',function(){requestId++;clearTimeout(timer);observer.disconnect();clearForm();document.documentElement.classList.remove('ag-restock-dialog-open');if(active)active.querySelector('a').focus();active=null;});chooser.addEventListener('change',function(){if(chooser.value)loadForm(chooser.value);else{requestId++;clearForm();status.hidden=false;status.textContent='Selecciona la opción que quieres.';}});observer=new MutationObserver(placeForm);}
 async function loadForm(variantId){var token=++requestId;clearTimeout(timer);clearForm();status.hidden=false;status.textContent='Cargando el formulario…';timer=setTimeout(function(){if(token===requestId&&dialog.open&&!status.hidden)status.textContent='El formulario está tardando en cargar. Puedes abrir el producto para solicitar el aviso.';},15000);try{var response=await fetch(active.dataset.productUrl+'.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)throw Error('product');var product=await response.json();var variant=product.variants.find(function(v){return String(v.id)===String(variantId);});if(token!==requestId||!dialog.open)return;if(!variant||String(product.id)!==active.dataset.productId)throw Error('variant');if(variant.available){clearTimeout(timer);status.textContent='¡Esta pieza ya está disponible! Puedes abrir el producto para añadirla a tu cesta.';return;}window.pushowl=window.pushowl||[];window.pushowl.push(function(){if(token!==requestId||!dialog.open)return;try{if(typeof window.pushowl.BISFormRender!=='function')throw Error('native form');mount.dataset.variantId=String(variant.id);window.pushowl.BISFormRender({currentVariant:function(){return variant;}});placeForm();}catch(error){clearTimeout(timer);status.textContent='No hemos podido abrir el aviso. Puedes solicitarlo desde el producto.';}});}catch(error){if(token!==requestId)return;clearTimeout(timer);status.textContent='No hemos podido cargar el formulario. Puedes solicitar el aviso desde el producto.';}}
 customElements.define('ag-card-restock',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='1';var link=this.querySelector('a');link.setAttribute('aria-haspopup','dialog');link.addEventListener('click',(event)=>{event.preventDefault();createDialog();active=this;title.textContent=this.dataset.productTitle;image.hidden=!this.dataset.productImage;if(this.dataset.productImage)image.src=this.dataset.productImage;fallback.href=this.dataset.productUrl;var variants=JSON.parse(this.querySelector('[data-ag-restock-variants]').textContent);chooser.replaceChildren(new Option('Elige una opción',''));variants.forEach(function(v){chooser.appendChild(new Option(v.title,String(v.id)));});choices.hidden=variants.length<2;status.hidden=false;status.textContent=variants.length>1?'Selecciona la opción que quieres.':'Cargando el formulario…';dialog.showModal();document.documentElement.classList.add('ag-restock-dialog-open');observer.observe(document.body,{childList:true,subtree:true});if(variants.length===1)loadForm(String(variants[0].id));});}});
})();
/* ALEGRIA V60: lotes de lectura con todos los agotados al final de la colección. */
(function(){
 if(customElements.get('ag-collection-grid'))return;
 customElements.define('ag-collection-grid',class extends HTMLElement{
  async connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='1';this.grid=this.querySelector('#product-grid');if(!this.grid)return;this.limit=Number(this.dataset.batch)||36;this.shown=this.limit;this.controls=document.createElement('div');this.controls.className='ag-collection-more';this.summary=document.createElement('p');this.summary.setAttribute('role','status');this.button=document.createElement('button');this.button.type='button';this.button.textContent='Ver más productos';this.controls.append(this.summary,this.button);this.grid.after(this.controls);this.button.addEventListener('click',()=>{var next=this.grid.children[this.shown];this.shown+=this.limit;this.show();if(next){next.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});var link=next.querySelector('a');if(link)link.focus({preventScroll:true});}});
   var pages=Number(this.dataset.pages)||1;
   if(pages>1){this.button.disabled=true;this.summary.textContent='Cargando la selección…';try{var seen=new Set(Array.from(this.grid.children).map(n=>n.dataset.productId));for(var page=1;page<=pages;page++){if(page===Number(this.dataset.page))continue;var url=new URL(location.href);url.searchParams.set('page',String(page));url.searchParams.set('section_id',this.grid.dataset.id);var response=await fetch(url.href);if(!response.ok)throw Error('collection');var doc=new DOMParser().parseFromString(await response.text(),'text/html');var cards=doc.querySelectorAll('#product-grid > li');if(!cards.length)throw Error('collection');cards.forEach(card=>{if(!seen.has(card.dataset.productId)){seen.add(card.dataset.productId);this.grid.appendChild(card);}});}var cards=Array.from(this.grid.children);cards.sort((a,b)=>Number(b.dataset.available==='true')-Number(a.dataset.available==='true'));this.grid.replaceChildren(...cards);var pagination=this.querySelector('.pagination-wrapper');if(pagination)pagination.hidden=true;}catch(error){this.controls.remove();return;}}
   this.button.disabled=false;this.show();
  }
  show(){var cards=Array.from(this.grid.children);cards.forEach((card,index)=>{card.hidden=index>=this.shown;});this.summary.textContent='Mostrando '+Math.min(this.shown,cards.length)+' de '+cards.length+' productos';this.button.hidden=this.shown>=cards.length;this.controls.hidden=cards.length<=this.limit;}
 });
})();

/* Alegría V109: mobile help links open the existing Shopify Inbox. */
(() => {
  if (window.agMobileChatV109) return;
  window.agMobileChatV109 = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const linkSelector = 'a[data-ag-open-chat]';
  let chatRoot, chatObserver, lastOpener, wasOpen = false, opening = false, scheduled = false;
  let retryTimer;

  const findChatRoot = () => (document.querySelector('shopify-chat[view="chat"]') || document.querySelector('shopify-chat'))?.shadowRoot;
  const findTrigger = () => findChatRoot()?.querySelector('button[part~="activator"]');
  const usableTrigger = () => {
    const button = findTrigger();
    return button && !button.disabled && button.getAttribute('aria-disabled') !== 'true' ? button : null;
  };

  const restoreFocus = () => {
    const opener = lastOpener;
    lastOpener = null;
    if (!opener) return;
    requestAnimationFrame(() => {
      const visible = opener.isConnected && !opener.closest('details:not([open])') && opener.getClientRects().length;
      const target = visible ? opener : document.querySelector('#Details-menu-drawer-container > summary');
      if (target?.getClientRects().length) target.focus({ preventScroll: true });
    });
  };

  const sync = () => {
    scheduled = false;
    const nextRoot = findChatRoot();
    if (nextRoot !== chatRoot) {
      chatObserver?.disconnect();
      chatRoot = nextRoot;
      if (chatRoot) {
        chatObserver = new MutationObserver(scheduleSync);
        chatObserver.observe(chatRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'aria-disabled', 'disabled'] });
      }
    }
    const trigger = usableTrigger();
    const ready = Boolean(trigger && document.querySelector(linkSelector));
    root.toggleAttribute('data-ag-mobile-chat-ready', ready);
    if (ready && retryTimer) {
      clearInterval(retryTimer);
      retryTimer = null;
    }
    const nativeTrigger = findTrigger();
    if (nativeTrigger) {
      const isOpen = nativeTrigger.getAttribute('aria-expanded') === 'true';
      if (wasOpen && !isOpen) restoreFocus();
      wasOpen = isOpen;
    }
  };

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  const afterMenuClose = (link, callback) => {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    const summary = drawer?.querySelector(':scope > summary');
    if (!drawer?.open || !drawer.contains(link) || !summary) return callback();
    let finished = false, fallback;
    const finish = () => {
      if (finished) return;
      finished = true;
      observer.disconnect();
      clearTimeout(fallback);
      callback();
    };
    const observer = new MutationObserver(() => { if (!drawer.open) finish(); });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    summary.click();
    if (!drawer.open) finish();
    else fallback = setTimeout(finish, 650);
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(linkSelector) : null;
    if (!link || !mobile.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    if (!usableTrigger()) return; // The normal contact-page link remains the fallback.
    event.preventDefault();
    if (opening) return;
    opening = true;
    lastOpener = link;
    afterMenuClose(link, () => {
      opening = false;
      const trigger = usableTrigger();
      if (!trigger) {
        lastOpener = null;
        root.removeAttribute('data-ag-mobile-chat-ready');
        window.location.assign(link.href);
        return;
      }
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
      scheduleSync();
    });
  });

  const init = () => {
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
    customElements.whenDefined('shopify-chat').then(scheduleSync);
    // Some app embeds attach their shadow root after the custom element is defined.
    retryTimer = setInterval(sync, 1000);
    setTimeout(() => { clearInterval(retryTimer); retryTimer = null; }, 60000);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* ALEGRIA V111 — Cart photos open an on-demand gallery; cart contents are untouched. */
(function () {
  if (window.agCartGalleryV111 || !window.HTMLDialogElement) return;
  window.agCartGalleryV111 = true;
  var dialog, title, photo, thumbs, count, status, previous, next, viewProduct;
  var opener, images = [], selected = 0, request = 0, controller, timeout;
  var cache = new Map();
  var pointerStart = null;

  function imageURL(value) {
    try {
      var src = typeof value === 'string' ? value : value && (value.src || value.url);
      if (!src) return '';
      var url = new URL(src, location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }
  function sized(value, width) {
    try {
      var url = new URL(value, location.origin);
      if (/\.shopify\.com$/.test(url.hostname) || url.pathname.indexOf('/cdn/shop/') === 0) url.searchParams.set('width', width);
      return url.href;
    } catch (_) { return value; }
  }
  function key(value) {
    try { return new URL(value, location.origin).pathname.split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/, ''); }
    catch (_) { return value; }
  }
  function close() { if (dialog && dialog.open) dialog.close(); }
  function show(index) {
    if (!images.length) return;
    selected = Math.max(0, Math.min(index, images.length - 1));
    photo.src = sized(images[selected].src, 1600);
    photo.alt = images[selected].alt || title.textContent;
    count.textContent = (selected + 1) + ' / ' + images.length;
    previous.disabled = selected === 0;
    next.disabled = selected === images.length - 1;
    thumbs.querySelectorAll('button').forEach(function (button, i) {
      button.setAttribute('aria-current', i === selected ? 'true' : 'false');
      button.tabIndex = i === selected ? 0 : -1;
    });
  }
  function render() {
    thumbs.replaceChildren();
    images.forEach(function (item, i) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      var thumb = document.createElement('img');
      thumb.src = sized(item.src, 144); thumb.alt = ''; thumb.width = 56; thumb.height = 56;
      thumb.loading = 'lazy';
      button.appendChild(thumb);
      button.addEventListener('click', function () { show(i); });
      button.addEventListener('keydown', function (event) {
        var target = event.key === 'ArrowRight' ? i + 1 : event.key === 'ArrowLeft' ? i - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? images.length - 1 : null;
        if (target === null) return;
        event.preventDefault(); event.stopPropagation(); show(target);
        thumbs.children[selected].focus();
      });
      thumbs.appendChild(button);
    });
    thumbs.hidden = images.length < 2;
    previous.hidden = next.hidden = images.length < 2;
    show(selected);
  }
  function create() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ag-cart-gallery';
    dialog.setAttribute('aria-labelledby', 'ag-cart-gallery-title');
    dialog.innerHTML = '<div class="ag-cart-gallery__header"><h2 id="ag-cart-gallery-title"></h2><button class="ag-cart-gallery__close" type="button" aria-label="Cerrar fotos" autofocus>×</button></div><div class="ag-cart-gallery__stage"><button class="ag-cart-gallery__previous" type="button" aria-label="Foto anterior">←</button><img class="ag-cart-gallery__photo" alt=""><button class="ag-cart-gallery__next" type="button" aria-label="Foto siguiente">→</button></div><div class="ag-cart-gallery__meta"><span class="ag-cart-gallery__count" role="status" aria-atomic="true"></span><a class="ag-cart-gallery__product">Ver el producto ↗</a></div><div class="ag-cart-gallery__thumbs" role="group" aria-label="Fotos del producto"></div><p class="ag-cart-gallery__status" role="status"></p>';
    document.body.appendChild(dialog);
    title = dialog.querySelector('h2');
    photo = dialog.querySelector('.ag-cart-gallery__photo');
    thumbs = dialog.querySelector('.ag-cart-gallery__thumbs');
    count = dialog.querySelector('.ag-cart-gallery__count');
    status = dialog.querySelector('.ag-cart-gallery__status');
    previous = dialog.querySelector('.ag-cart-gallery__previous');
    next = dialog.querySelector('.ag-cart-gallery__next');
    viewProduct = dialog.querySelector('.ag-cart-gallery__product');
    dialog.querySelector('.ag-cart-gallery__close').addEventListener('click', close);
    previous.addEventListener('click', function () { show(selected - 1); });
    next.addEventListener('click', function () { show(selected + 1); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(selected + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    var stage = dialog.querySelector('.ag-cart-gallery__stage');
    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' || event.target.closest('button')) return;
      pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    }, { passive: true });
    stage.addEventListener('pointerup', function (event) {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;
      var dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) show(selected + (dx < 0 ? 1 : -1));
    }, { passive: true });
    stage.addEventListener('pointercancel', function () { pointerStart = null; }, { passive: true });
    dialog.addEventListener('close', function () {
      request++; clearTimeout(timeout);
      if (controller) controller.abort();
      controller = null; pointerStart = null;
      document.documentElement.classList.remove('ag-cart-gallery-open');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    });
  }
  async function open(link, productURL) {
    create(); opener = link;
    var token = ++request;
    if (controller) controller.abort();
    clearTimeout(timeout);
    var row = link.closest('.cart-item');
    var existingPhoto = link.querySelector('img') || (row && row.querySelector('.cart-item__image'));
    var rowTitle = row && row.querySelector('.cart-item__name');
    title.textContent = link.dataset.agGalleryTitle || (rowTitle && rowTitle.textContent.trim()) || (existingPhoto && existingPhoto.alt) || 'Fotos del producto';
    viewProduct.href = link.href;
    var initial = existingPhoto && imageURL(existingPhoto.currentSrc || existingPhoto.src);
    images = initial ? [{ src: initial, alt: title.textContent }] : [];
    selected = 0; render();
    photo.hidden = !initial;
    count.textContent = initial ? '1 / 1' : '';
    status.textContent = 'Cargando el resto de fotos…';
    document.documentElement.classList.add('ag-cart-gallery-open');
    dialog.showModal();
    try {
      var product = cache.get(productURL.href);
      if (!product) {
        controller = new AbortController();
        timeout = setTimeout(function () { if (controller && token === request) controller.abort(); }, 10000);
        var response = await fetch(productURL.href, { headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw Error('product');
        product = await response.json();
        if (token !== request || !dialog.open) return;
        cache.set(productURL.href, product);
      }
      if (token !== request || !dialog.open) return;
      clearTimeout(timeout);
      var found = [], seen = new Set();
      (product.images || []).forEach(function (item) {
        var src = imageURL(item);
        if (!src || seen.has(key(src))) return;
        seen.add(key(src)); found.push({ src: src, alt: (item && item.alt) || product.title || title.textContent });
      });
      if (!found.length) throw Error('images');
      images = found;
      selected = Math.max(0, images.findIndex(function (item) { return initial && key(item.src) === key(initial); }));
      photo.hidden = false; render(); status.textContent = '';
    } catch (_) {
      if (token !== request || !dialog.open) return;
      clearTimeout(timeout);
      status.textContent = 'Puedes abrir el producto para ver todas sus fotos.';
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-ag-cart-gallery]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url;
    try {
      url = new URL(link.dataset.agProductUrl || link.href, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      url.search = ''; url.hash = ''; url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    } catch (_) { return; }
    event.preventDefault(); open(link, url);
  });
})();

/* ALEGRIA V111 — A single short cart-count pulse, only when the confirmed count increases. */
(function () {
  if (window.agCartCountV111) return;
  window.agCartCountV111 = true;
  var installed = new WeakSet();
  function read(icon) {
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble) return 0;
    var visible = bubble.querySelector('[aria-hidden="true"]');
    var value = (visible ? visible.textContent : bubble.textContent).match(/\d+/);
    return value ? Number(value[0]) : null;
  }
  function install() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || installed.has(icon)) return;
    installed.add(icon);
    var lastCount = read(icon), timer;
    new MutationObserver(function () {
      var count = read(icon);
      if (count === null) return;
      var increased = lastCount !== null && count > lastCount;
      lastCount = count;
      if (!increased || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var bubble = icon.querySelector('.cart-count-bubble');
      if (!bubble) return;
      clearTimeout(timer);
      bubble.classList.remove('ag-cart-count--added');
      requestAnimationFrame(function () {
        if (!bubble.isConnected) return;
        bubble.classList.add('ag-cart-count--added');
        timer = setTimeout(function () { bubble.classList.remove('ag-cart-count--added'); }, 600);
      });
    }).observe(icon, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pageshow', function () { lastCount = read(icon); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
  document.addEventListener('shopify:section:load', install);
})();
